export type MapCoordinates = { lat: number; lng: number };

type CoordinateRecord = Record<string, unknown>;

function coordinateValue(value: unknown) {
  if (typeof value === 'number') return value;
  if (typeof value === 'string' && value.trim()) return Number(value);
  return Number.NaN;
}

/**
 * Converts provider-shaped latitude/longitude fields into a Leaflet-safe
 * coordinate pair. Invalid or incomplete values are omitted before rendering.
 */
export function toMapCoordinates(value: unknown): MapCoordinates | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  const record = value as CoordinateRecord;
  const lat = coordinateValue(record.lat ?? record.latitude);
  const lng = coordinateValue(record.lng ?? record.longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng) || lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  return { lat, lng };
}
